import { Component, OnInit, ViewChild, Inject, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { EFormViewerComponent } from '../../../../shared-components/e-forms/e-form-viewer/e-form-viewer.component';
import { EFormDataObject } from '../../../../shared-components/e-forms/e-formDataObject.model';
import { EForm } from '../../../../shared-components/e-forms/e-form.model';
import { EFormInstance } from '../../../../shared-components/e-forms/e-form-instance.model';
import { EFormConfiguration } from '../../../../shared-components/e-forms/e-form-config.model';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { EFormService } from '../../../../shared-components/e-forms/e-form.service';
import { SpinnerService } from '../../../../shared-components/spinner/spinner.service';

@AutoUnsubscribe({ includeArrays: true })
@Component({
    selector: 'app-behavior-letter-viewer-modal',
    templateUrl: './behavior-letter-viewer-modal.component.html',
    styleUrls: ['./behavior-letter-viewer-modal.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class BehaviorLetterViewerModalComponent implements OnInit, OnDestroy {

    @ViewChild(EFormViewerComponent, { static: true }) eFormViewer: EFormViewerComponent;
    eFormData: EFormDataObject;
    selectedForm: EForm;
    selectedInstance: EFormInstance;
    config = new EFormConfiguration();

    errors: ErrorList[] = [];

    isPreview: boolean = false;
    isReview: boolean = false;
    editable: boolean = true;
    showNextPreviousButtons: boolean = false;
    isLP: boolean = true;
    isFP: boolean = true;

    subscriptions: Subscription[] = [];

    constructor(
        private dialogRef: MatDialogRef<BehaviorLetterViewerModalComponent>,
        private eFormService: EFormService,
        private spinnerService: SpinnerService,
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data) {
            if (data.config) {
                this.config = data.config;
            }

        }

        if (this.config.ReadOnly) {
            this.editable = false;
        }

    }

    ngOnInit() {
        this.selectedForm = _.cloneDeep(this.eFormService.selectedForm);
        this.eFormData = _.cloneDeep(this.eFormService.selectedFormData);

        if (this.eFormData.Tabs.length > 1 || this.eFormData.Tabs[0].Pages.length > 1) {
            this.showNextPreviousButtons = true;
        }

        this.subscriptions.push(this.eFormService.observableIsFirstPageStream$.subscribe(isFirstPage => {
            this.isFP = isFirstPage;
        }));
        this.subscriptions.push(this.eFormService.observableIsLastPageStream$.subscribe(isLastPage => {
            this.isLP = isLastPage;
        }));
    }

    ngOnDestroy() {

    }

    async printClick() {
        //  Initialize pdf
        this.eFormService.pdfDataURIs = [];

        this.eFormViewer.fileNameOverride = true;
        this.eFormViewer.localPrint = true;
        this.eFormViewer.showAllConditionalsPrint = true;
        if( this.config && this.config.Title) {
            this.eFormViewer.fileNameInput = this.config.Title;
        }
        else {            
            this.eFormViewer.fileNameInput = 'form';
        }

        this.eFormViewer.showPrintDiv = true;        
        this.spinnerService.showSpinner = true;
    }

    previousClick() {
        this.eFormViewer.previousClick();
    }

    nextClick() {
        this.eFormViewer.nextClick();
    }

    saveClick() {

    }    

    cancelClick() {
        this.dialogRef.close('cancel');
    }
}
